<script setup>
import { Wrench, Check, Circle, ChevronRight } from 'lucide-vue-next'
import Card from './Card.vue'
import CtaButton from './CtaButton.vue'
import Stepper from './Stepper.vue'
import { status } from '../lib/status'

defineProps({
  maintenance: { type: Object, required: true },
})
</script>

<template>
  <Card title="Manutenção" :icon="Wrench" link-label="Ver detalhes" link-href="/manutencao">
    <p class="text-2xl font-bold text-up-orange">
      {{ maintenance.progress }}%
      <span class="text-base font-medium text-up-navy">concluído</span>
    </p>

    <div class="mt-5">
      <Stepper :steps="maintenance.steps" />
    </div>

    <ul class="mt-6 divide-y divide-slate-100 overflow-hidden rounded-lg border border-slate-100">
      <li v-for="task in maintenance.tasks" :key="task.label">
        <button
          type="button"
          class="flex w-full items-center gap-3 px-4 py-3.5 text-left transition-colors hover:bg-up-bg"
        >
          <span
            class="flex h-6 w-6 shrink-0 items-center justify-center rounded-full"
            :class="status(task.state).icon"
            aria-hidden="true"
          >
            <Check v-if="task.state === 'done'" class="h-4 w-4" stroke-width="3" />
            <Circle v-else class="h-3 w-3 fill-current" />
          </span>
          <span class="text-sm text-up-navy">{{ task.label }}</span>
          <span class="sr-only">{{ status(task.state).label }}</span>
          <ChevronRight class="ml-auto h-4 w-4 shrink-0 text-slate-400" aria-hidden="true" />
        </button>
      </li>
    </ul>

    <div class="mt-auto pt-5">
      <CtaButton href="/manutencao">Acompanhar manutenção</CtaButton>
    </div>
  </Card>
</template>
